import { ApiStatus } from '../../types';

export const repaymentDefaultAEM = {
    'heading': '{heading}',
    'description': '{description}',
    'chooseAccountHeading': '{chooseAccountHeading}',
    'notificationHeading': '{notificationHeading}',
    'defaultNotificationDescription': '{defaultNotificationDescription}',
    'monthlyNotificationDescription': '{monthlyNotificationDescription}',
    'frequencyTypeHeading': '{frequencyTypeHeading}',
    'accountNumberSeparation': ' ',
    'frequency': [
        {
            'key': 'Weekly',
            'value': 'Weekly',
        },
        {
            'key': 'Fortnightly',
            'value': 'Fortnightly',
        },
        {
            'key': 'Monthly',
            'value': 'Monthly',
        },
    ],
    'frequencyDescription': '{frequencyDescription}',
    'confirmButtonText': '{confirmButtonText}',
    'validations': {
        'hardValidations': {
            'account': {
                'defaultErrorMessage': '{Select repayment account}',
            },
            'frequency': {
                'defaultErrorMessage': 'Select repayment frequency',
            },
        },
    },
};

export interface RepaymentAccount {
    productName: string;
    number: string;
    frequency?: string;
}

export interface RepaymentEndpoints {
    getRepaymentUrl: string;
    saveRepaymentUrl?: string;
}

export interface RepaymentApiData extends RepaymentAccount {
    content: string;
    selectedRepaymentAccount: RepaymentAccount;
    availableRepaymentAccount: Record<number, RepaymentAccount>;
}

export interface RepaymentDetailErrorMessage {
    productName?: string
    frequency?: string
}

export interface RepaymentState {
    content: RepaymentAEM;
    apiEndpoints: RepaymentEndpoints;
    repaymentAccounts: Record<number, RepaymentAccount>;
    selectedAccount?: RepaymentAccount;
    getRepaymentApiStatus: ApiStatus;
    submitRepaymentApiStatus: ApiStatus;
}

export type RepaymentAEM = typeof repaymentDefaultAEM;
